import type { TranslationKey } from '@/i18n';

export interface RequestDraft {
  topic: string;
  direction: string;
  deadline: string;
  comment: string;
}

export type RequestErrors = Partial<Record<keyof RequestDraft, TranslationKey>>;

const startOfToday = (): number => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return now.getTime();
};

export const validateRequest = (draft: RequestDraft): RequestErrors => {
  const errors: RequestErrors = {};

  if (draft.topic.trim().length < 6) errors.topic = 'requests.error.topic';

  if (!draft.deadline) {
    errors.deadline = 'requests.error.deadline';
  } else {
    const deadline = new Date(`${draft.deadline}T00:00:00`).getTime();
    if (Number.isNaN(deadline) || deadline < startOfToday()) {
      errors.deadline = 'requests.error.deadlinePast';
    }
  }

  return errors;
};
